<template>
    <div class="living-options-dwellings">
      <div class="row">
        <div class="col-12">
          <div class="dwellings">
            <h3>Dwellings</h3>
            <button class="btn btn-sm btn-primary mb-4" @click="addDwelling">Add Dwelling</button>
            <div class="mb-2">
              <input class="form-control" type="text" v-model="dwellingFilterText" placeholder="Filter dwellings">
            </div>
            <v-table
              :columns="[
                { 
                  label: 'Label',
                  field: 'label'
                },
                { 
                  label: 'Builder',
                  field: 'builderLabel',
                  options: {
                    sortable: true,
                    return: function (fieldValue) {
                      return fieldValue
                    }
                  }
                },
                { 
                  label: 'Attached to Lots', 
                  field: 'associatedLots', 
                  options: {
                    sortable: false,
                    return: function (fieldValue) {
                      if (fieldValue === 'Not Found') {
                        return '-'
                      } else {
                        return fieldValue.map(field => `<div>${field.label}</div>`).join('')
                      }
                    },
                  }
                },
              ]"
              :rows="filteredDwellings"
              :show-active-toggle="activeUser.access.indexOf('live-toggle') !== -1"
              save-action="SAVE_DWELLING"
              @edit="editDwelling($event._id)"
              @clone="cloneDwelling($event)"
              @delete="deleteDwelling($event._id)"
            />
          </div>
        </div>
      </div>  
    </div>     
</template>
<script>
import { mapGetters } from 'vuex'
import VTable from '@/components/VTable'

export default {
  components: { 
    VTable
  },

  data () {
    return {
      dwellingFilterText: '',
    }
  },

  computed: {
    ...mapGetters([
      'dwellings'
    ]),

    activeUser () {
      return this.$store.getters.user
    },

    filteredDwellings () {
      return this.dwellings.filter(dwelling => dwelling.label.toLowerCase().includes(this.dwellingFilterText.toLowerCase()))
    },
  },

  created () {
    this.$store.dispatch('FETCH_DWELLINGS')
  },

  methods: {
    async addDwelling () {
      const newDwelling = await this.$store.dispatch('ADD_NEW_DWELLING')
      this.$store.dispatch('SAVE_DWELLING', newDwelling)
      this.editDwelling(newDwelling._id)
    },

    async cloneDwelling (dwelling) {
      const clonedDwelling = await this.$store.dispatch('CLONE_DWELLING', dwelling)
      this.$store.dispatch('SAVE_DWELLING', clonedDwelling)
    },

    deleteDwelling (id) {
      if (confirm('Are you sure?')) {
        this.$store.dispatch('DELETE_DWELLING', id)
      }
    },

    editDwelling (id) {
      this.$router.push(`dwellings/${id}`)
    }
  },
}
</script>
